import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useHistory, useParams } from 'react-router-dom';
import { useGetCmsArticleQuery } from '../../apis/cmsApi/cms.hooks.api';
import { BaseLayout } from '../../components/Layout/Layout';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';
import { Routes } from '../../routes/types';

import './NewsDetailsView.css';

type NewsDetailsRouteParam = {
  newsId?: string;
};

type NewsDetailsViewProps = {};

export const NewsDetailsView: React.FC<NewsDetailsViewProps> = () => {
  const languagesInfo = useLanguage();
  const history = useHistory();
  const back = useBack();
  const t = languagesInfo[0];
  const locale = languagesInfo[2];
  const { newsId } = useParams<NewsDetailsRouteParam>();

  const { data: news } = useGetCmsArticleQuery(
    { locale, newsId: newsId || '' },
    { skip: !newsId }
  );

  useEffect(() => {
    if (!newsId) {
      history.replace(Routes.Home);
    }
  }, [history, newsId]);

  return (
    <BaseLayout hasBack onBackClick={back} title={t('pageTitles.news')}>
      <div className="news-details--container">
        {news ? (
          <ReactMarkdown>{news.content}</ReactMarkdown>
        ) : (
          <div>Content not exist</div>
        )}
      </div>
    </BaseLayout>
  );
};
